import React, { Fragment } from "react";
import PropTypes from "prop-types";

import Row from "../../common/Row";
import Button from "../../common/Button";
import TextInput from "../../common/TextInput";
import AutoComplete from "../../common/AutoComplete";
import ConfirmModal from "../../common/ConfirmModal";

const OverzichtFilterForm = (props) => {
    const {
        filter,
        onExportSportclubs,
        onLink,
        onChange,
        locaties,
        errors,
        sporttakken,
        onSearch,
        onScrollToAanvragen,
        onOpenExportModal,
        onCloseExportModal,
        exportModalIsOpen,
        federatieEmailAdres,
        nameFilterHasFocus
    } = props;

    function handleOnExportSportclubs() {
        return function (event) {
            onExportSportclubs(event);
        };
    }

    function handleOnOpenExportModal() {
        return function (event) {
            onOpenExportModal(event);
        };
    }

    function handleOnCloseExportModal() {
        return function (event) {
            onCloseExportModal(event);
        };
    }

    const exportModalText = <p>Verzend mij een export van alle sportclubs en verstuur dit naar het onderstaande e-mailadres.<br />Je zal binnen de 30 minuten een mail ontvangen met de lijst van jouw sportclubs.</p>;

    const buttonStyle = { marginLeft: ".83333%", marginRight: ".83333%" };
    const hasVCode = filter.vCode && filter.vCode.length > 0;
    const hasPoid = filter.poId && filter.poId.length > 0;
    const hasOndernemingsnummer = filter.ondernemingsnummer && filter.ondernemingsnummer.length > 0;

    return (
        <div>
            {exportModalIsOpen && <ConfirmModal
                isOpen={exportModalIsOpen}
                mainText={exportModalText}
                confirmAction={handleOnExportSportclubs()}
                cancelAction={handleOnCloseExportModal()}
                confirmText="Ga verder"
                cancelText="Annuleer"
                inputValue={federatieEmailAdres}
                inputName={"federatieEmailAdres"}
                inputLabel="e-mailadres"
                onChange={onChange}
                title="Exporteer alle sportclubs"
            />}

            <Row>
                <p style={{ 'color': '#39b4e8' }} className="o-col-6">&nbsp;</p>
                <Button onClick={onScrollToAanvragen} text="Openstaande aanvragen" className="c-button--small o-col-2 c-input" style={buttonStyle} />
                <Button onClick={handleOnOpenExportModal()} text="Exporteer alle sportclubs" className="c-button--small o-col-2 c-input" style={buttonStyle} />
                <Button onClick={onLink} text="Sportclub melden" className="c-button--small o-col-2 c-input" style={buttonStyle} />
            </Row>
            <Row>
                <TextInput
                    name="naam"
                    label="Naam"
                    value={filter.naam}
                    size={6}
                    onChange={onChange}
                    disabled={hasPoid || hasVCode || hasOndernemingsnummer}
                    hasFocus={nameFilterHasFocus}
                />
                <AutoComplete
                    minSearchLength={1}
                    items={locaties}
                    size={6}
                    name="locatie"
                    label="Waar"
                    value={filter.locatie}
                    onChange={onChange}
                    disabled={hasPoid || hasVCode || hasOndernemingsnummer}
                    useDefaultItem={false}
                    clearable
                />
            </Row>
            <Row>
                <TextInput
                    name="ondernemingsnummer"
                    label="Ondernemingsnummer"
                    value={filter.ondernemingsnummer}
                    size={6}
                    onChange={onChange}
                    disabled={(filter.naam && filter.naam.length > 0) ||
                        hasVCode ||
                        hasPoid ||
                        (filter.locatie && filter.locatie.length > 0) ||
                        (filter.sporttak && filter.sporttak.length > 0) ||
                        (filter.telefoonorgsm && filter.telefoonorgsm.length > 0) ||
                        (filter.email && filter.email.length > 0) ||
                        (filter.website && filter.website.length > 0)}
                    validationMessage={errors ? errors['ondernemingsnummer'] : ""}
                />
                <TextInput
                    name="vCode"
                    label="V-Code"
                    value={filter.vCode}
                    size={6}
                    onChange={onChange}
                    disabled={(filter.naam && filter.naam.length > 0) ||
                        hasOndernemingsnummer ||
                        hasPoid ||
                        (filter.locatie && filter.locatie.length > 0) ||
                        (filter.sporttak && filter.sporttak.length > 0) ||
                        (filter.telefoonorgsm && filter.telefoonorgsm.length > 0) ||
                        (filter.email && filter.email.length > 0) ||
                        (filter.website && filter.website.length > 0)}
                    onEnter={onSearch}
                />
           
            </Row>
            <Row>
                <TextInput
                    name="email"
                    label="E-mail"
                    value={filter.email}
                    size={6}
                    onChange={onChange}
                    disabled={hasPoid || hasVCode || hasOndernemingsnummer}
                    validationMessage={errors ? errors['email'] : ""}
                />
                <TextInput
                    name="telefoonorgsm"
                    label="Telefoon/GSM"
                    value={filter.telefoonorgsm}
                    size={6}
                    onChange={onChange}
                    disabled={hasPoid || hasVCode || hasOndernemingsnummer}
                    validationMessage={errors ? errors['telefoonOrGsm'] : ""}
                />
               
            </Row>
            <Row>
                <AutoComplete
                    minSearchLength={1}
                    items={sporttakken}
                    size={6}
                    name="sporttak"
                    label="Sporttak"
                    value={filter.sporttak}
                    onChange={onChange}
                    disabled={hasPoid || hasVCode || hasOndernemingsnummer}
                    useDefaultItem={false}
                    clearable
                />
                <TextInput
                    name="website"
                    label="Website"
                    value={filter.website}
                    size={6}
                    onChange={onChange}
                    disabled={hasPoid || hasVCode || hasOndernemingsnummer}
                    validationMessage={errors ? errors['website'] : ""}
                />
                </Row>
                <Row>
                <TextInput
                    name="poId"
                    label="PO-id"
                    value={filter.poId}
                    size={6}
                    onChange={onChange}
                    disabled={(filter.naam && filter.naam.length > 0) ||
                        (filter.vCode && filter.vCode.length > 0) ||
                        (filter.locatie && filter.locatie.length > 0) ||
                        (filter.sporttak && filter.sporttak.length > 0) ||
                        hasOndernemingsnummer ||
                        (filter.telefoonorgsm && filter.telefoonorgsm.length > 0) ||
                        (filter.email && filter.email.length > 0) ||
                        (filter.website && filter.website.length > 0)}
                    clearable
                    validationMessage={errors ? errors['poId'] : ""}
                />
            </Row>
            <Row>
                <Button style={{ marginLeft: '.83333%', paddingLeft: '1.1em', float: "right" }} onClick={onSearch} text="Zoek" className="o-col-1 c-input" />
            </Row>
        </div>
    );
};

OverzichtFilterForm.propTypes = {
    filter: PropTypes.object,
    onExportSportclubs: PropTypes.func,
    onLink: PropTypes.func,
    locaties: PropTypes.array,
    sporttakken: PropTypes.array,
    onChange: PropTypes.func,
    onSearch: PropTypes.func,
    onScrollToAanvragen: PropTypes.func,
    onOpenExportModal: PropTypes.func,
    onCloseExportModal: PropTypes.func,
    exportModalIsOpen: PropTypes.bool,
    federatieEmailAdres: PropTypes.string,
    nameFilterHasFocus: PropTypes.bool,
    errors: PropTypes.object,
};

export default OverzichtFilterForm;